export default __webpack_public_path__ + "static/media/hbs-k-cbb-banner-1.99a67b7f.jpg";